import api from "./Api";

class CondicaoService {
  GetCondicao(payload) {
    return api.get("/v1/condicao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCondicao(payload) {
    return api.post("/v1/condicao/", payload).then((response) => {
      return response.data;
    });
  }

  PutCondicao(payload) {
    return api.put("/v1/condicao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCondicao(payload) {
    return api.delete("/v1/condicao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCondicaoOData(payload) {
    return api.get("/OData/Condicao" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new CondicaoService();
